export const changeFeatureDataReducer = (state = null, action) => {
  switch (action.type) {
    case "CHANGE_FEATURE_DATA":
      return action.payload.featureData;
    default:
      return state;
  }
};
